export default {
  white: "#FFFFFF",
  black: "#000000",
  purple: {
    50: "#F4F1FA",
    100: "#E3DDF2",
    200: "#C1B5E3",
    300: "#957FCE",
    400: "#7356BF",
    500: "#574191",
    600: "#453473",
    700: "#2E224C",
  },
  blue: {
    10: "#1E1B39",
    50: "#EFF3FE",
    100: "#D4E2FC",
    200: "#A0BFF8",
    300: "#5B91F5",
    400: "#276EF1",
    500: "#1E54B7",
    600: "#174291",
    700: "#102C60",
  },
  green: {
    50: "#E6F2ED",
    100: "#ADDEC9",
    200: "#66D19E",
    300: "#06C167",
    400: "#048848",
    500: "#03703C",
    600: "#03582F",
    700: "#10462D",

    800: "#1D5E30",
    900: "#1DBF73",
  },
  chateau: {
    50: "#F1FCF3",
    100: "#E6F4EA",
    200: "#C0F2CD",
  },
  lime: {
    50: "#F2F7ED",
    100: "#E0ECD2",
    200: "#BCD69D",
    300: "#8BB956",
    400: "#67A421",
    500: "#4E7C19",
    600: "#3D6213",
    700: "#29410D",
  },
  yellow: {
    50: "#FFFAF0",
    100: "#FFF2D9",
    200: "#FFE3AC",
    300: "#FFCF70",
    400: "#FFC043",
    500: "#996F00",
    600: "#996F00",
    700: "#674D1B",
    800: "#E8A31E",
  },
  red: {
    50: "#FFEFED",
    100: "#FED7D2",
    200: "#F1998E",
    300: "#CBCBCB",
    400: "#E11900",
    500: "#AB1300",
    600: "#870F00",
    700: "#5A0A00",
  },
  gray: {
    10: "#9291A5",
    50: "#F6F6F6",
    100: "#EEEEEE",
    200: "#E2E2E2",
    300: "#CBCBCB",
    400: "#AFAFAF",
    500: "#757575",
    600: "#545454",
    700: "#333333",
    800: "#848A90",
    border: "#E9EBF0",
  },
  inputGrey: {
    50: "#FEFEFE",
    100: "#FCFCFC",
    200: "#FAFAFA",
    300: "#F8F8F8",
    400: "#F7F7F7",
    500: "#F5F5F5",
    600: "#DFDFDF",
    700: "#AEAEAE",
    800: "#878787",
    900: "#676767",
  },
  estationsGreen: {
    50: "#E8F3EA",
    100: "#B9D8BF",
    200: "#97C6A0",
    300: "#68AB74",
    400: "#4A9B59",
    500: "#1D8230",
    600: "#1A762C",
    700: "#155C22",
    800: "#10481A",
    900: "#0C3714",
  },
  brown: {
    50: "#F7F3F1",
    100: "#EBE0DB",
    200: "#D2BBB0",
    300: "#B18977",
    400: "#99644C",
    500: "#744C3A",
    600: "#5C3C2E",
    700: "#3D281E",
  },
  orange: {
    50: "#FFF3EF",
    100: "#FFE1D6",
    200: "#FABDA5",
    300: "#FA9269",
    400: "#FF6937",
    500: "#B45427",
    600: "#9A3F21",
    700: "#672A16",
  },
  chateauGreen: {
    500: "#30B354",
    300: "#90E5A7",
  },
  neutral: {
    100: "#F2F2F2",
    600: "#475569",
  },
  textColor: {
    500: "#4B5563",
    600: "#444D5A",
    900: "#20242A",
  },
  remis: {
    50: "#E6EDED",
  },

  brown: {
    100: "#AC7F5E",
  },
};
